/* eslint-disable max-len */
/**
 * https://jira.aws.dnb.com/browse/CPL-1780
 * Current Markets:
 *        United States(US), Canada(CA)
 *        United Kingdom(GB), Ireland (IE), Switzerland (CH), Hungary (HU), Poland (PL), Czech (CZ), Slovenia(SI)
 * Default Country Code is US until user login
 */

import { allRegionsFeaturesList } from '@helpers/countriesByRegion';
import { getLanguageCode } from '@helpers/languages';
import { useAppSelector } from '@redux/reduxHooks';
import { RootState } from '@redux/store';

const useCountryCodeInfo = () => {
    const userCountryCode = useAppSelector((state: RootState) => state.app.profileDetails.countryCode) || getLanguageCode()?.slice(-2).toLocaleUpperCase();
    // Before login, userLanguage should come from else condition but state.profileDetails.languagePreference will be set to en-us.So added a check state.profileDetails.email
    const userEmail = useAppSelector((state: RootState) => state.app.profileDetails.email);
    const userLanguagePreference = useAppSelector((state: RootState) => state.app.profileDetails.languagePreference);
    const userLanguage = userEmail ? userLanguagePreference : getLanguageCode();
    const defaultUSFeaturesList = allRegionsFeaturesList[0].featuresList;
    const isCountryCodeAvailableInList = allRegionsFeaturesList.some((featuresList) => featuresList.countryCode === userCountryCode);
    const countryCode = isCountryCodeAvailableInList ? userCountryCode : 'US';
    const featuresList = allRegionsFeaturesList.filter((list) => list.countryCode === countryCode && (list.languagePreference === userLanguage || list.languagePreference === ''))[0]?.featuresList || defaultUSFeaturesList;
    return { userCountryCode, featuresList };
};

export default useCountryCodeInfo;
